function stripTrailingSlashes(value: string): string {
  return value.replace(/\/+$/g, '');
}

const PUBLIC_SITE_ORIGIN = 'https://rewardlyai.com';
const COMMUNITY_BASE_PATH = '/community';

export function getSiteOrigin(): string {
  const fromEnv = (process.env.REACT_APP_SITE_URL || process.env.REACT_APP_WEBSITE_URL || '').trim();
  if (fromEnv) return stripTrailingSlashes(fromEnv);
  return PUBLIC_SITE_ORIGIN;
}

function slugify(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '')
    .replace(/-+/g, '-');
}

function pickFirstString(obj: any, keys: string[]): string {
  for (const k of keys) {
    const v = obj?.[k];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return '';
}

function normalizeSlugCandidate(value: string): string {
  const v = value.trim();
  if (!v) return '';

  // If backend sends full URL or a /community/... path, extract the last segment.
  try {
    if (/^https?:\/\//i.test(v)) {
      const url = new URL(v);
      return url.pathname.split('/').filter(Boolean).pop() || '';
    }
  } catch {
    // ignore
  }

  const parts = v.split('/').filter(Boolean);
  return parts[parts.length - 1] || '';
}

export function getCommunityPostUrl(post: { _id?: string; id?: string | number; title?: string; slug?: string; [key: string]: any }): string {
  const origin = getSiteOrigin();

  const directSlug = normalizeSlugCandidate(
    pickFirstString(post, ['slug', 'seoSlug', 'postSlug', 'communitySlug'])
  );

  let slug = directSlug;
  if (!slug) {
    const prefixRaw = post?.id ?? post?.postId ?? post?.communityPostId ?? post?.communityId;
    const prefix = typeof prefixRaw === 'number' || typeof prefixRaw === 'string' ? String(prefixRaw).trim() : '';
    const titleSlug = post?.title ? slugify(String(post.title)) : '';

    if (prefix && titleSlug) slug = `${prefix}-${titleSlug}`;
    else if (titleSlug) slug = titleSlug;
    else if (typeof post?._id === 'string' && post._id.trim()) slug = post._id.trim();
    else slug = 'post';
  }

  return `${stripTrailingSlashes(origin)}${COMMUNITY_BASE_PATH}/${encodeURIComponent(slug)}`;
}
